<template>
    <div>
        <div class="mdss-yy no-select">
            <div class="layout">
                <div class="swiper-wrapper" style="">
                    <div class="swiper-slide on" style="width: 34.3%;">
                        <a href="javascript:;" @click="clickTab($event, 0, '문화')">문화</a>
                    </div>
                    <div class="swiper-slide" style="width: 34.3%;">
                        <a href="javascript:;" @click="clickTab($event, 3, '관광')">관광</a>
                    </div>
                    <div class="swiper-slide" style="width: 34.3%;">
                        <a href="javascript:;" @click="clickTab($event, 4, '스포츠')">스포츠</a>
                    </div>
                </div>
            </div>
          </div>
          <div class="layout">
              <h2 class="title blind">주요통계지표</h2>
          </div>
          <div class="layout">
              <!-- 문화 -->
              <div class="chart--wrapper" v-show="tabIndex === 0">
                  <div class="chart--box" id="chartBox01">
                      <h3 class="chart--box__title">{{ clsSysNm }}&nbsp;(단위: {{unitNm}})
                          <a href="#/" @click="mhChart1(srcId)">
                              <img src="../../assets/img/more.png" alt="더보기" title="바로가기" >
                          </a>
                      </h3>
                      <div class="chart--box__content">
                          <div>
                              <VChart class="chart" :option="mainChartLineOptionMh" style="width: 100%; height: 400px;" autoresize></VChart>
                          </div>
                      </div>
                  </div>
                  <div class="chart--box" id="chartBox01">
                      <h3 class="chart--box__title">{{ clsSysNmt }}&nbsp;(단위: {{unitNmt}})
                          <a href="#/" @click="mhChart2(srcIdt)">
                              <img src="../../assets/img/more.png" alt="더보기" title="바로가기" >
                          </a>
                      </h3>
                      <div class="chart--box__content">
                          <div>
                              <VChart class="chart" :option="mainChartBarOptionBy" style="width: 100%; height: 400px;" autoresize></VChart>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- 관광 -->
              <div class="chart--wrapper" v-show="tabIndex === 3">
                  <div class="chart--box" id="chartBox01">
                      <h3 class="chart--box__title">{{ clsSysNmtr }}&nbsp;(단위: {{unitNmtr}})
                          <a href="#/" @click="mhChart3(srcIdtr)">
                              <img src="../../assets/img/more.png" alt="더보기" title="바로가기" >
                          </a>
                      </h3>
                      <div class="chart--box__content">
                          <div>
                              <VChart class="chart" :option="mainChartBarOptionPa" style="width: 100%; height: 400px;" autoresize></VChart>
                          </div>
                      </div>
                  </div>
                  <div class="chart--box" id="chartBox01">
                      <h3 class="chart--box__title">{{ clsSysNmf }}&nbsp;(단위: {{unitNmf}})
                          <a href="#/" @click="mhChart4(srcIdf)">
                              <img src="../../assets/img/more.png" alt="더보기" title="바로가기" >
                          </a>
                      </h3>
                      <div class="chart--box__content">
                          <div>
                              <VChart class="chart" :option="mainChartBarOptionDt" style="width: 100%; height: 400px;" autoresize></VChart>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- 스포츠 -->
              <div class="chart--wrapper" v-show="tabIndex === 4">
                  <div class="chart--box" id="chartBox01">
                      <h3 class="chart--box__title">스포츠산업 사업체수, 종사자수 현황 (단위: 개, 천명) </h3>
                      <div class="chart--box__content">
                          <div class="chart-row">
                              <div>
                                  <VChart class="chart" :option="mainChartLineOptionSio" style="width: 100%; height: 400px;"  autoresize></VChart>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="chart--box" id="chartBox01">
                    <h3 class="chart--box__title">스포츠산업 매출액 현황 (단위: 십억원)</h3>
                          <div class="chart--box__content">
                              <div class="chart-row">
                                  <div>
                                      <VChart class="chart" :option="mainChartLineOptionSit" style="width: 100%; height: 400px;"  autoresize></VChart>
                                  </div>
                              </div>
                          </div>
                    </div>
                    <div class="chart--box" id="chartBox01">
                        <h3 class="chart--box__title">20년전 대비 20대초반의 신장, 체중 변화 (단위: cm, kg)</h3>
                          <div class="chart--box__content">
                            <div>
                              <VChart class="chart" :option="mainChartBarOptionPs" style="width: 100%; height: 400px;" autoresize></VChart>
                            </div>
                        </div>
                    </div>
              </div>
          </div>
    </div>
</template>

<script>
import $ from 'jquery'
import * as api from '@/api/StatCharts.js'
import chartOption from '../../assets/js/chartOption'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart, LineChart, BarChart } from 'echarts/charts'

import {
	ToolboxComponent, GridComponent,
	TitleComponent,
	TooltipComponent,
	LegendComponent
} from 'echarts/components'

import VChart from 'vue-echarts'
import CommonUtil from '../../assets/js/commonUtil'
import eChartUtils from '../../assets/js/chartUtils'
import GridOption from '../../assets/js/gridOption'

use([
	CanvasRenderer,
	PieChart,
	BarChart,
	LineChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	ToolboxComponent,
	GridComponent
])

export default {
	name: 'StatCharts',
	components: {
		VChart,
		swiper,
		swiperSlide
	},
	data () {
		return {
			tabIndex: 0,
			mainChartLineOptionMh: {}, // 그래프1 차트 틀
			mainChartBarOptionBy: {}, // 그래프2 차트 틀
			mainChartBarOptionPa: {},
			mainChartBarOptionDt: {},
			mainChartLineOptionSio: {},
			mainChartLineOptionSit: {},
			mainChartBarOptionPs: {},
			clsSysNm: '',
			clsSysNmt: '',
			clsSysNmtr: '',
			clsSysNmf: '',
			unitNm: '',
			unitNmt: '',
			unitNmtr: '',
			unitNmf: ''
			// srcId: null,

		}
	},

	created () {
		this.mhChart1() // 그래프1 데이터 틀
		this.mhChart2()
		this.mhChart3()
		this.mhChart4()
		this.mhChart5()
		this.mhChart6()
		this.mhChart7()
	},
	mounted () {
	},

	methods: {
		async  mhChart1 (srcId) { // 문화예술행사 관람률 변화 추이
			const upClsSysNo = 'DATA-000044'
			let titleRowData = {} // const read-only?

			if (srcId) {
				window.open('/portal/staticPop/' + srcId + '/' + 1)
			}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo })// 인수값 1개

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[0]
				}
			}
			if (titleRowData) {
				this.clsSysNm = titleRowData.clsSysNm
				this.unitNm = titleRowData.unitNm
				this.srcId = titleRowData.srcId
			}
			// console.log(titleRowData)
			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId,
				// upClsSysNo:  'DATA-000044',
				searchStartDate: '2014',
				searchEndDate: '2022'
			}

			const resultData = await api.searchChartData(paramData) // 차트의 이름&수치 데이터 조회
			this.mainChartLineOptionMh = chartOption.mainLineChart() // chartOption.js에서 차트의 틀을 불러와서 그래프1차트 만들기
			this.mainChartLineOptionMh.title.text = this.clsSysNm

			var xAxisYearList = [] // 연도 데이터 리스트

			if (resultData) {
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					const chartS = { // 데이터틀 담는 부분
						name: '',
						type: 'line',
						areaStyle: {},
						barWidth: '10%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: []
					}
					chartS.name = resultData.data.nameData[i].attrNm // 차트 데이터의 이름+legned 이름 지정
					var chartDataList = []

					for (let j = 0; j < resultData.data.seriesData.length; j++) { // 7개
						chartDataList.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])

						var year = resultData.data.seriesData[j].creTme // 차트의 연도 데이터 가져오기

						if (!xAxisYearList.includes(year)) {
							xAxisYearList.push(year)
						}
					}
					chartS.data = chartDataList

					this.mainChartLineOptionMh.xAxis[0].data = xAxisYearList
					this.mainChartLineOptionMh.series.push(chartS)
				}
			}
		},

		async mhChart2 (srcIdt) { // 분야별 문화행사 관람율
			const upClsSysNo = 'DATA-000044'
			let titleRowData = {}

			if (srcIdt) {
				window.open('/portal/staticPop/' + srcIdt + '/' + 1)
			}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo })// 인수값 1개

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[1]
				}
			}
			if (titleRowData) {
				this.clsSysNmt = titleRowData.clsSysNm
				this.unitNmt = titleRowData.unitNm
				this.srcIdt = titleRowData.srcId
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId,
				searchStartDate: '2019',
				searchEndDate: '2022'
			}

			const resultData = await api.searchChartData(paramData)
			this.mainChartBarOptionBy = chartOption.mainBarChartmh()

			var xAxisData = [] // x축 데이터 (항목명 nameData)
			var yAxisData = [] // y축 데이터 (수치,년도 seriesData)

			if (resultData) {
				// x축 데이터 설정
				for (let i = 0; i < resultData.data.nameData.length; i++) { // 9개
					xAxisData.push(resultData.data.nameData[i].attrNm)
				}
				// y축 데이터 설정
				for (let j = 0; j < resultData.data.seriesData.length; j++) { // 4개
					const chartS = {
						// name: resultData.data.seriesData[j]['attrNm'], // seriesData의 이름 설정
						type: 'bar',
						barWidth: '10%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: [] // 수치 값 배열
					}
					chartS.name = resultData.data.seriesData[j].creTme // 차트 데이터의 이름 연도로 지정

					for (let i = 0; i < resultData.data.nameData.length; i++) { // 수치데이터
						chartS.data.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
					}

					yAxisData.push(chartS)// 수치, 년도값
				}

				// x축 및 y축 데이터 설정
				this.mainChartBarOptionBy.xAxis[0].data = xAxisData
				this.mainChartBarOptionBy.series = yAxisData
			}
		},

		async  mhChart3 (srcIdtr) { // 여행지출액 총량
			const upClsSysNo = 'DATA-000045'
			let titleRowData = {}

			if (srcIdtr) {
				window.open('/portal/staticPop/' + srcIdtr + '/' + 1)
			}

			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo })

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[0]
				}
			}
			if (titleRowData) {
				this.clsSysNmtr = titleRowData.clsSysNm
				this.unitNmtr = titleRowData.unitNm
				this.srcIdtr = titleRowData.srcId
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId,
				searchStartDate: '2019',
				searchEndDate: '2022'
			}

			const resultData = await api.searchChartData(paramData)

			this.mainChartBarOptionPa = chartOption.mainBarChartGg()

			var xAxisData = [] // x축 데이터 (nameData, 전체/숙박/당일 )
			var yAxisData = [] // y축 데이터 (년도 seriesData)

			if (resultData) {
				// x축 데이터 설정
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					xAxisData.push(resultData.data.nameData[i].attrNm)
				}
				// y축 데이터 설정
				for (let j = 0; j < resultData.data.seriesData.length; j++) {
					const chartS = {
						// name: resultData.data.seriesData[j]['attrNm'], // seriesData의 이름 설정
						type: 'bar',
						barWidth: '15%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: [] // 수치 값 배열
					}
					chartS.name = resultData.data.seriesData[j].creTme // 차트 데이터의 이름 연도로 지정

					for (let i = 0; i < resultData.data.nameData.length; i++) {
						chartS.data.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
					}
					yAxisData.push(chartS)
				}
				// x축 및 y축 데이터 설정
				this.mainChartBarOptionPa.xAxis[0].data = xAxisData
				this.mainChartBarOptionPa.series = yAxisData
			}
		},

		async  mhChart4 (srcIdf) { // 국내여행횟수
			const upClsSysNo = 'DATA-000045'
			let titleRowData = {}

			if (srcIdf) {
				window.open('/portal/staticPop/' + srcIdf + '/' + 1)
			}
			const titleData = await api.searchChartTitleData({ upClsSysNo: upClsSysNo })

			if (titleData) {
				if (titleData.data && titleData.data.nameData.length > 0) {
					titleRowData = titleData.data.nameData[1]
				}
			}
			if (titleRowData) {
				this.clsSysNmf = titleRowData.clsSysNm
				this.unitNmf = titleRowData.unitNm
				this.srcIdf = titleRowData.srcId
			}

			const paramData = {
				clsSysNo: titleRowData.clsSysNo,
				entityId: titleRowData.entityId,
				searchStartDate: '2019',
				searchEndDate: '2022'
			}

			const resultData = await api.searchChartData(paramData)

			this.mainChartBarOptionDt = chartOption.mainBarChartGg()

			var xAxisData = [] // x축 데이터 (항목명 nameData)
			var yAxisData = [] // y축 데이터 (년도 seriesData)

			if (resultData) {
				// x축 데이터 설정
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					xAxisData.push(resultData.data.nameData[i].attrNm)
				}
				// y축 데이터 설정
				for (let j = 0; j < resultData.data.seriesData.length; j++) {
					const chartS = {
						// name: resultData.data.seriesData[j]['attrNm'], // seriesData의 이름 설정
						type: 'bar',
						barWidth: '15%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: [] // 수치 값 배열
					}
					chartS.name = resultData.data.seriesData[j].creTme // 차트 데이터의 이름 지정

					for (let i = 0; i < resultData.data.nameData.length; i++) {
						chartS.data.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
					}
					yAxisData.push(chartS)
				}
				// x축 및 y축 데이터 설정
				this.mainChartBarOptionDt.xAxis[0].data = xAxisData
				this.mainChartBarOptionDt.series = yAxisData
			}
		},

		async chartType (resultData, chartIndex) { // 스포츠산업 사업체수, 종사자수 현황 통합
			this.mainChartLineOptionSio = chartOption.mainLineBarChart()

			const resultNameData = resultData.data.nameData
			const resultSeriesData = resultData.data.seriesData

			const nameData = []
			const seriesData = resultSeriesData

			for (let i = 0; i < resultNameData.length; i++) { // 3번
				if (i === 1) {
					continue // nameData[1] 매출액 제외
				}
				nameData.push(resultNameData[i]) // 2개
			}

			const xAxis = []
			const legendData = []// y축 label이름 배열에 담기
			const chartSeries = []// 표형태 배열에 담기
			const xAxisData = [] // x축 연도 데이터 담기

			// y축
			for (let i = 0; i < nameData.length; i++) { // 2번
				legendData.push(nameData[i].attrNm)// label값 nameData로 지정

				const series = {
					name: legendData[i],
					type: i === 0 ? 'bar' : 'line',
					yAxisIndex: i === 1 ? 1 : 0,
					barWidth: '20%',
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}
				chartSeries.push(series)
			}

			const datas1 = []// 사업체
			const datas2 = []// 종사자

			const seriesList = chartSeries[0]
			const seriesListT = chartSeries[1]

			for (let sIdx = 0; sIdx < seriesData.length; sIdx++) { // 연도 기준 + 한 그래프에 그릴수 있는 x축 데이터 갯수 결정
				xAxisData.push(seriesData[sIdx].creTme)

				datas1.push({
					name: legendData[0], // datas1 데이터 포인트의 레전드 이름을 설정
					value: seriesData[sIdx]['dataCtnt' + (chartIndex * 2 + 1)]// 사업체수
				})
				datas2.push({
					name: legendData[1], // datas2 데이터 포인트의 레전드 이름을 설정
					value: seriesData[sIdx]['dataCtnt' + (chartIndex * 2 + 3)]// 종사자수
				})
			}
			seriesList.data = datas1
			seriesListT.data = datas2

			xAxis.push(
				{
					type: 'category',
					data: xAxisData
				}
			)

			this.mainChartLineOptionSio.legend.data = legendData
			this.mainChartLineOptionSio.xAxis = xAxis
			this.mainChartLineOptionSio.series = chartSeries
		},

		async mhChart5 () { // 스포츠산업 사업체수,종사자수 현황
			const paramData = {
				clsSysNo: 'DATA-000075',
				// entityId: 'ENTT-000085', //개발
				entityId: 'ENTT-000086', // 운영
				searchStartDate: '2019',
				searchEndDate: '2021'
			}
			const resultData = await api.searchChartData(paramData)
			this.chartType(resultData, 0)
		},

		async mhChart6 () { // 스포츠산업 매출액 현황
			const paramData = {
				clsSysNo: 'DATA-000075',
				// entityId: 'ENTT-000085', //개발
				entityId: 'ENTT-000086', // 운영
				searchStartDate: '2019',
				searchEndDate: '2021'
			}

			const resultData = await api.searchChartData(paramData)
			this.mainChartLineOptionSit = chartOption.mainLineChart()

			var xAxisYearList = [] // 연도 데이터 리스트

			if (resultData) {
				const dataIndex = 1
				for (let i = 0; i < resultData.data.nameData.length; i++) {
					if (i !== dataIndex) {
						continue
					}
					const chartS = { // 데이터틀 담는 부분
						name: '',
						type: 'line',
						areaStyle: {},
						barWidth: '10%',
						label: {
							show: true,
							position: 'top',
							formatter: function (p) {
								return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
							}
						},
						data: []
					}
					chartS.name = resultData.data.nameData[i].attrNm // 차트 데이터의 이름 지정

					var chartDataList = [] // 수치 값 배열방에 넣어주기

					for (let j = 0; j < resultData.data.seriesData.length; j++) { // 차트 수치 for문
						chartDataList.push(resultData.data.seriesData[j]['dataCtnt' + (i + 1)])
						var year = resultData.data.seriesData[j].creTme // 차트의 연도 데이터 가져오기

						if (!xAxisYearList.includes(year)) {
							xAxisYearList.push(year)
						}
					}
					chartS.data = chartDataList

					this.mainChartLineOptionSit.xAxis[0].data = xAxisYearList
					this.mainChartLineOptionSit.series.push(chartS)
				}
			}
		},

		async CharTypePso (resultData1, resultData2, resultData3, resultData4) { // 20년전 대비 20대초반의 신장, 체중 변화
			this.mainChartBarOptionPs = chartOption.mainBarChartSi()

			const resultNameData1 = resultData1.data.nameData // 1
			const resultSeriesData1 = resultData1.data.seriesData // 2

			// const resultNameData2 = resultData2.data.nameData;
			const resultSeriesData2 = resultData2.data.seriesData

			const resultNameData3 = resultData3.data.nameData
			const resultSeriesData3 = resultData3.data.seriesData

			// const resultNameData4 = resultData4.data.nameData;
			const resultSeriesData4 = resultData4.data.seriesData

			const nameData = [] // x축 데이터
			const nameData3 = [] // x축 데이터

			const seriesData1 = resultSeriesData1 // 년도, 수치 (데이터1)
			const seriesData2 = resultSeriesData2 // 년도, 수치 (데이터2)
			const seriesData3 = resultSeriesData3 // 년도, 수치 (데이터3)
			const seriesData4 = resultSeriesData4 // 년도, 수치 (데이터3)

			for (let i = 0; i < resultNameData1.length; i++) {
				nameData.push(resultNameData1[i].attrNm) // 배열에 이름만 추가
			}

			for (let i = 0; i < resultNameData3.length; i++) {
				nameData3.push(resultNameData3[i].attrNm) // 배열에 이름만 추가
			}

			const xAxis = []
			const legendData = []
			const chartSeries = []
			const xAxisData = []

			// y축
			for (let i = 0; i < nameData.length; i++) {
				legendData.push(nameData[i] + ' (남자)') // 남자와 여자 구분하여 추가
				legendData.push(nameData[i] + ' (여자)')
				legendData.push(nameData3[i] + ' (남자)')
				legendData.push(nameData3[i] + ' (여자)')

				const series1 = {
					name: legendData[i * 4],
					type: 'bar',
					barWidth: '10%',
					yAxisIndex: 0,
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				const series2 = {
					name: legendData[i * 4 + 1],
					type: 'bar',
					barWidth: '10%',
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				const series3 = {
					name: legendData[i * 4 + 2],
					type: 'line',
					barWidth: '10%',
					yAxisIndex: legendData[i] === 2 | 3 ? 1 : 0,
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				const series4 = {
					name: legendData[i * 4 + 3],
					type: 'line',
					barWidth: '10%',
					yAxisIndex: legendData[i] === 2 | 3 ? 1 : 0,
					emphasis: {
						focus: 'series'
					},
					label: {
						show: true,
						position: 'top',
						formatter: function (p) {
							return p.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
						}
					},
					data: []
				}

				chartSeries.push(series1)
				chartSeries.push(series2)
				chartSeries.push(series3)
				chartSeries.push(series4)
			}

			const datas1 = []
			const datas2 = []
			const datas3 = []
			const datas4 = []

			for (let sIdx = 0; sIdx < seriesData1.length; sIdx++) { // 1번
				xAxisData.push(seriesData1[sIdx].creTme)
				for (let i = 0; i < nameData.length; i++) { // 각 년도에 아래 수치 한번씩만 찍어냄
					datas1.push({
						value: seriesData1[sIdx]['dataCtnt' + (i + 1)]
					})
					datas2.push({
						value: seriesData2[sIdx]['dataCtnt' + (i + 1)]
					})
					datas3.push({
						value: seriesData3[sIdx]['dataCtnt' + (i + 1)]
					})
					datas4.push({
						value: seriesData4[sIdx]['dataCtnt' + (i + 1)]
					})
				}
			}

			for (let i = 0; i < chartSeries.length; i++) {
				if (i % 4 === 0) {
					chartSeries[i].type = 'bar'
					chartSeries[i].data = datas1
				} else if (i % 4 === 1) {
					chartSeries[i].type = 'bar'
					chartSeries[i].data = datas2
				} else if (i % 4 === 2) {
					chartSeries[i].type = 'line'
					chartSeries[i].data = datas3
				} else {
					chartSeries[i].type = 'line'
					chartSeries[i].data = datas4
				}
			}
			xAxis.push({
				type: 'category',
				data: xAxisData
			})

			this.mainChartBarOptionPs.legend.data = legendData
			this.mainChartBarOptionPs.xAxis = xAxis
			this.mainChartBarOptionPs.series = chartSeries
		},

		async mhChart7 () { // 20년전 대비 20대초반의 신장, 체중 변화
			const paramData1 = {
				clsSysNo: 'DATA-000077',
				entityId: 'ENTT-000087',
				searchStartDate: '2001',
				searchEndDate: '2021'
			}
			const paramData2 = {
				clsSysNo: 'DATA-000077',
				entityId: 'ENTT-000088',
				searchStartDate: '2001',
				searchEndDate: '2021'
			}
			const paramData3 = {
				clsSysNo: 'DATA-000078',
				entityId: 'ENTT-000089',
				searchStartDate: '2001',
				searchEndDate: '2021'
			}
			const paramData4 = {
				clsSysNo: 'DATA-000078',
				entityId: 'ENTT-000090',
				searchStartDate: '2001',
				searchEndDate: '2021'
			}
			const resultData1 = await api.searchChartData(paramData1)
			const resultData2 = await api.searchChartData(paramData2)

			const resultData3 = await api.searchChartData(paramData3)
			const resultData4 = await api.searchChartData(paramData4)

			this.CharTypePso(resultData1, resultData2, resultData3, resultData4)
		},
		// 탭 클릭 이벤트
		clickTab (event, idx, tabNm) {
			this.tabIndex = idx
			const tabMenu = document.getElementsByClassName('swiper-slide')
			tabMenu.forEach(obj => obj.classList.remove('on'))
			event.target.parentElement.classList.add('on')
		}
	}
}
</script>
<style scoped>
.chart {
  height: 300px;
}
</style>
